import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { listEVisitRequestsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';
import EVisitRequestsTable from './eVisitRequestsTable';
import EVisitRequestsFilterButton from './eVisitRequestsFilterButton';
import EVisitRequestsFilterStatusBar from './eVisitRequestsFilterStatusBar';

const EVisitRequests = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.eVisitRequests, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.E_VISIT_REQUESTS)) {
      dispatch(listEVisitRequestsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.E_VISIT_REQUESTS) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <EVisitRequestsFilterStatusBar />
      </Grid>
      <Grid item>
        <EVisitRequestsFilterButton />
      </Grid>
      <EVisitRequestsTable />
    </Grid>
  );
};

export default EVisitRequests;
